import "../../resources/js/modules/flexible-content";
